// extracted by mini-css-extract-plugin
export var attribution = "_81-4";
export var authorName = "_81-5";
export var quote = "_81-3";
export var testimonial = "_81-2";
export var trustedBy = "_81-0";
export var trustedByLabel = "_81-1";